import { useMutation } from 'react-query';

import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';
import { vodUrl } from '../../../../../client-config.js';

const usePatchMediaAssetMutation = (options) => {
  const firebase = useFirebase();
  const orgId = useOrgId();

  return useMutation({
    mutationFn: async ({ mediaAssetId, data }) => {
      const idToken = await firebase.getIdToken();
      const fetchUrl = new URL(`${vodUrl}/v1/orgs/${orgId}/media-assets/${mediaAssetId}`);

      try {
        const response = await fetch(`${fetchUrl}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          mode: 'cors',
          body: JSON.stringify({
            data,
          }),
        });

        if (response.ok) {
          return data;
        } else {
          throw new Error(response);
        }
      } catch (e) {
        throw e;
      }
    },
    ...options,
  });
};

export default usePatchMediaAssetMutation;
